<div class="alert-box">
    <div class="modal-header">
        <button type="button" class="close" aria-label="Close" (click)="onCloseModal()">
            <span aria-hidden="true">&times;</span>
        </button>
        <h4 class="modal-title">{{ "closing_page_website" | translate }}</h4>
    </div>
    <div class="modal-body">
        <p class="mb-20">{{ "closing_website_page_description" | translate }}</p>
    </div>

    <div class="modal-footer">
        <button type="button" class="btn btn-default" (click)="onCancel()">
            {{ "exit_without_page_saving" | translate }}
        </button>
        <button type="button" class="btn btn-primary" (click)="onConfirm()">
            {{ "save_page_and_exit" | translate }}
        </button>
    </div>
</div>
